export interface DataTableTopInputFilter {
    label: string;
    attribute: string;
    type?: string;
    placeholder?: string;
    defaultValue?: any;
}

export class DataTableColumn {
    attribute!: string;
    header!: string;
    filter?: string | any[];
    style?: object;
    width?: string;
    options?: any[];
    filterOptionsSource?: string | any;
    defaultFilterValue?: any;
    sortable?: boolean;
    filterMinAttribute?: string;
    filterMaxAttribute?: string;
    cellClass?: string;
}

export interface DataTablePagination {
    page: number;
    pageSize: number;
    pageItemCount: number;
    totalCount: number;
    totalPages: number;
}

export default interface DataTableConfig {
    searchModel: any,
    columns: DataTableColumn[];
    data: any[];
    pagination?: DataTablePagination | null;
    inEvidence?: (item: any) => boolean;
    topInputFilters?: DataTableTopInputFilter[];
}

